import { yupResolver } from '@hookform/resolvers/yup'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'

import GlobalInputComponent from '../../../../../../components/events/forms/detail/Components/GlobalInputComponent'

import { cn } from '../../../../../../lib/utils'

import { EventSchedulingModel } from '../../../../../../models/operations-tab/operations-tab.model'
import { DateEnum } from '../../../data/operations.data.const'

import {
  HOURS_12_OPTIONS,
  MINUTES_OPTIONS,
  SECONDS_OPTIONS,
} from '../../../../../../fakeData/TimeList'

interface IProps {
  h: string
  m: string
  s: string
  saveHandler: (h: string, m: string, s: string) => void
}
const eventSchedulingFormValidationSchema = EventSchedulingModel.validationSchema()

export const TimeSelector: React.FC<IProps> = ({ saveHandler, s, m, h }) => {
  const [incrementHours, setIncrementHours] = useState(h || HOURS_12_OPTIONS[0].value)
  const [incrementMinutes, setIncrementMinutes] = useState(m || MINUTES_OPTIONS[0].value)
  const [incrementSeconds, setIncrementSeconds] = useState(s || SECONDS_OPTIONS[0].value)

  const { control } = useForm({
    defaultValues: { title: '' },
    resolver: yupResolver(eventSchedulingFormValidationSchema),
    mode: 'onSubmit',
  })
  const [editMode, setEditMode] = useState(false)

  const onchangeIncrementHandler = async (value: string, type: DateEnum) => {
    try {
      switch (type) {
        case DateEnum.h:
          setIncrementHours(value)
          break
        case DateEnum.m:
          setIncrementMinutes(value)
          break
        default:
          setIncrementSeconds(value)
      }
    } catch (error) {
      console.error(error)
    }
  }

  if (!editMode) {
    return (
      <div
        className="cursor-pointer min-w-[100px] text-center underline hover:no-underline"
        onClick={() => setEditMode(true)}
      >
        {incrementHours}:{incrementMinutes}:{incrementSeconds}
      </div>
    )
  }
  return (
    <div
      className={cn(
        'cursor-pointer flex items-center text-center underline hover:no-underline',
        editMode && 'no-underline'
      )}
    >
      <GlobalInputComponent
        type="select"
        className="flex-1 px-[0!important] h-[40px] bg-[#f0f0f0] flex items-center outline-0 text-gray-500 w-full focus:ring-0 focus:outline-0 no-underline rounded-l-[4px]"
        placeholder="00"
        defaultValue={incrementHours}
        onChange={(value) => onchangeIncrementHandler(value, DateEnum.h)}
        value={HOURS_12_OPTIONS}
        control={control}
        isTimeSelector={true}
        isdisableInput={true}
      />
      :
      <GlobalInputComponent
        type="select"
        className="flex-1 px-[0!important] h-[40px] border-none flex items-center outline-0 text-gray-500 w-full focus:ring-0 focus:border-0 focus:outline-0 bg-[#f0f0f0] !rounded-none"
        placeholder="00"
        defaultValue={incrementMinutes}
        value={MINUTES_OPTIONS}
        onChange={(value) => onchangeIncrementHandler(value, DateEnum.m)}
        isTimeSelector={true}
        isdisableInput={true}
        control={control}
      />
      :
      <GlobalInputComponent
        type="select"
        className="flex-1 px-[0!important] h-[40px] outline-0 flex items-center text-gray-500 w-full focus:ring-0 focus:border-0 focus:outline-0 bg-[#f0f0f0] rounded-r-[4px]"
        placeholder="00"
        defaultValue={incrementSeconds}
        value={SECONDS_OPTIONS}
        onChange={(value) => onchangeIncrementHandler(value, DateEnum.s)}
        isTimeSelector={true}
        isdisableInput={true}
        control={control}
      />
      <button
        className="ms-3 text-[12px] hover:opacity-50 transition-all"
        onClick={() => {
          setEditMode(false)
        }}
      >
        Cancel
      </button>
      <button
        className="ms-3 me-5 text-SeabiscuitMainThemeColor text-[12px] hover:opacity-50 transition-all"
        onClick={() => {
          setEditMode(false)
          saveHandler(incrementHours, incrementMinutes, incrementSeconds)
        }}
      >
        Save
      </button>
    </div>
  )
}
